import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { IllustrativeView } from '@component/illustrative_view.component';
import { TopBar } from '@component/top_bar.component';
import { useResolveController } from '@visiba/instantiation';
import { useEffect } from 'react';
import { CreateNewMessageController } from '../view_create_new_message.controller';

export function ScreenError() {
	const controller = useResolveController(CreateNewMessageController);
	const analytics = useAnalyticContext();

	function handleRestart() {
		analytics.trackEvent('Clicked', 'Restart button');
		controller.goToReceptionHome();

		// TODO: Remove when angular is gone!
		if (
			(window as typeof window & { __TEMP__overrideNavigation: Record<string, unknown> | undefined })['__TEMP__overrideNavigation'] !=
			null
		) {
			window.location.reload();
		}
	}

	useEffect(
		function whenMounted() {
			analytics.service.trackPageView({
				customTitle: 'Create new message: Error',
			});
		},
		[analytics],
	);

	return (
		<>
			<TopBar.Content onAbort={null} />

			<IllustrativeView
				title={withTranslation('View.CreateNewMessage.ErrorInterrupted.Title')}
				description={withTranslation('View.CreateNewMessage.ErrorInterrupted.Body')}
				illustration='error'
				callToAction={withTranslation('View.CreateNewMessage.ErrorInterrupted.Button')}
				callToActionCallback={handleRestart}
			/>
		</>
	);
}
